import { atomWithReset } from "jotai/utils";

export interface CouncilStepValues {
  profession: string | null;
  professionName: string | null;
  councilNumber: string;
  councilAcronym: string | null;
  uf: string;
  procedures: string | null;
}

export const councilStepAtom = atomWithReset<CouncilStepValues>({
  profession: null,
  professionName: null,
  councilNumber: "",
  councilAcronym: null,
  uf: "SP",
  procedures: null,
});

